import React from 'react';
import {Totals} from '../../../../common/components/Totals/Totals';
import {classes} from './TotalsSection.st.css';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../Widget/ControllerContext';
import {SubtotalRow} from './TotalRows/SubtotalRow';
import {FeeRows} from './TotalRows/FeeRows';
import {CouponTotalsRow} from './TotalRows/CouponTotalsRow';
import {GiftCardTotalsRow} from './TotalRows/GiftCardTotalsRow';
import {DeliveryTotalsRow} from './TotalRows/DeliveryTotalsRow';
import {TaxTotalsRow} from './TotalRows/TaxTotalsRow';
import {PaymentBreakdown} from './TotalRows/PaymentBreakdown';
import {TotalRow} from './TotalRows/TotalRow';
import {SubscriptionsProjections} from '../SubscriptionsProjections/SubscriptionsProjections';
import {TotalsSkeleton} from './TotalsSkeleton';
import {CalculateCartErrorNotification} from './CalculateCartErrorNotification/CalculateCartErrorNotification';
import {DiscountRows} from './TotalRows/DiscountRows';

export enum TotalsSectionDataHooks {
  Section = 'TotalsSectionDataHooks.Section',
  TotalsSectionWrapper = 'TotalsSectionDataHooks.TotalsSectionWrapper',
  ShippingRowValue = 'TotalsSectionDataHooks.ShippingRowValue',
  TotalSection = 'TotalsSectionDataHooks.TotalSection',
  TotalRow = 'TotalsSectionDataHooks.TotalRow',
  TotalRowValue = 'TotalsSectionDataHooks.TotalRowValue',
  TaxIncluded = 'TotalsSectionDataHooks.TaxIncluded',
  TaxIncludedSectionTitle = 'TotalsSectionDataHooks.TaxIncludedSectionTitle',
  TaxIncludedTaxRow = 'TotalsSectionDataHooks.TaxIncludedTaxRow',
  PaymentBreakdownSection = 'TotalsSectionDataHooks.PaymentBreakdownSection',
  PayNowRow = 'TotalsSectionDataHooks.PayNowRow',
  PayAfterTrialRow = 'TotalsSectionDataHooks.PayAfterTrialRow',
  PayLaterRow = 'TotalsSectionDataHooks.PayLaterRow',
  SubtotalRow = 'TotalsSectionDataHooks.SubtotalRow',
  ShippingRow = 'TotalsSectionDataHooks.ShippingRow',
  TaxRow = 'TotalsSectionDataHooks.TaxRow',
  TaxSection = 'TotalsSectionDataHooks.TaxSection',
  AdditionalFeeRow = 'TotalsSectionDataHooks.AdditionalFeeRow',
  AdditionalFeesSection = 'TotalsSectionDataHooks.AdditionalFeesSection',
  AppliedCouponRow = 'TotalsSectionDataHooks.AppliedCouponRow',
  DiscountRow = 'TotalsSectionDataHooks.DiscountRow',
  GiftCardRow = 'TotalsSectionDataHooks.GiftCardRow',
  Loader = 'TotalsSectionDataHooks.Loader',
  CalculateCartErrorNotification = 'TotalsSectionDataHooks.CalculateCartErrorNotification',
}

export const TotalsSection = () => {
  const {cartSummary, hasCalculateCartError, shouldShowDiscounts} = useControllerProps().checkoutStore;
  const localeKeys = useLocaleKeys();

  return (
    <>
      <section
        className={classes.totalsContainer}
        data-hook={TotalsSectionDataHooks.Section}
        aria-label={localeKeys.checkout.orderTotal.fullSection.ariaLabel()}>
        <Totals dataHook={TotalsSectionDataHooks.TotalsSectionWrapper}>
          <SubtotalRow />
          {cartSummary ? (
            <>
              {shouldShowDiscounts && <DiscountRows />}
              <FeeRows fees={cartSummary.additionalFees} groupTitle={localeKeys.checkout.additionalFees()} />
              {!shouldShowDiscounts && <CouponTotalsRow />}
              <GiftCardTotalsRow />
              <DeliveryTotalsRow />
              <TaxTotalsRow />
              <FeeRows fees={cartSummary.platformFees} groupTitle={localeKeys.checkout.order_summary.serviceFees()} />
              <TotalRow />
              <PaymentBreakdown />
            </>
          ) : (
            <div data-hook={TotalsSectionDataHooks.Loader}>
              <TotalsSkeleton />
            </div>
          )}
        </Totals>
      </section>
      {cartSummary && <SubscriptionsProjections />}
      {hasCalculateCartError && <CalculateCartErrorNotification />}
    </>
  );
};
